module.exports = __webpack_public_path__ + "img/21.b6fc6a58.png";